<template>
<b-modal ref="lockdownModal" size="lg" title="Upgrade Required" header-bg-variant="primary" header-text-variant="light">
        <h5><i class="fas fa-lock mr-2"></i> Premium Feature Locked</h5>
        <p>This feature is exclusively available to our Premium members.</p>
        <p>To unlock this and many other powerful tools, please upgrade your membership. You'll get unlimited access to all of our features, helping you to build a comprehensive and professional portfolio.</p>
        <div slot="modal-footer" class="upgrade-footer">
            <b-row class="upgrade-buttons">
                <b-col cols="6" >
                    <b-button class="upgrade-btn" variant="info" size="md" @click="upgradeMonthly">
                      <div class="upgrade-btn-content">
                        <div class="upgrade-btn-title">Monthly membership</div>
                        <div class="upgrade-btn-price">£2.99</div>
                        <small class="upgrade-btn-period">per month</small>
                      </div>
                    </b-button>
                </b-col>
                <b-col cols="6">
                    <b-button class="upgrade-btn" variant="info" size="md" @click="upgradeYearly">
                      <div class="upgrade-btn-content">
                        <div class="upgrade-btn-title">Yearly membership</div>
                        <div class="upgrade-btn-price">£24.99</div>
                        <small class="upgrade-btn-period">per year</small>
                      </div>
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "LockdownPopup",
    methods: {
        show() {
            this.$refs.lockdownModal.show();
        },
        upgrade() {
            this.$router.push({name: 'payment-management'});
            this.$refs.lockdownModal.hide();
        },
        upgradeYearly() {
            window.open('https://pay.gocardless.com/AL0009FCR4M3J0', '_blank');
        },
        upgradeMonthly() {
            window.open('https://pay.gocardless.com/AL0009FCS98227', '_blank');
        }
    }
}
</script>

<style scoped>
.upgrade-footer {
    width: 100%;
    text-align: center;
    padding: 0;
    margin: 0;
}

.upgrade-buttons {
    width: 100%;
    margin: 0;
}

.upgrade-btn {
    width: 100%;
    padding: 15px 10px;
    height: auto;
    min-height: 80px;
}

.upgrade-btn-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.upgrade-btn-title {
    font-weight: 600;
    font-size: 0.9rem;
}

.upgrade-btn-price {
    font-weight: bold;
    font-size: 1.1rem;
}

.upgrade-btn-period {
    color: #495057;
    font-size: 0.8rem;
}
</style>
